import React, { Component } from 'react';
import { Link, Redirect } from "react-router-dom";
import Header from '../../Header';
import $, { nodeName } from 'jquery';
import Autocomplete , { createFilterOptions }  from '@material-ui/lab/Autocomplete';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';

const CustomAutocomplete = withStyles({
    root: {
        fontFamily: "Poppins-Regular",
        padding:"0px 12px",
        "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
          // Default transform is "translate(14px, 20px) scale(1)""
          // This lines up the label with the initial cursor position in the input
          // after changing its padding-left.
          transform: "translate(34px, 20px) scale(1);"
        }
      },
      inputRoot: {
        color: "#555",
        border:"1",
        borderColor:"#DBE1EA",
        fontFamily: "Poppins-Regular",
        fontSize:"12px",
        // This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
        '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
          // Default left padding is 6px
          paddingLeft: 0
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DBE1EA"
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DBE1EA"
          
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#DBE1EA",
          border:"1px solid",
        }
    },
    listbox:{
        fontFamily: "Poppins-Regular",
        fontSize:"12px",
    },
    popupIndicator:{
        display:"none",
    },
    tag: {
      backgroundColor: "#F1FCFF",
      borderColor:'#D9F6FD',
      border:"1px solid",
      fontFamily: "Poppins-Regular",
      fontSize:"12px",
      lineHeight:"18px",
      height: 24,
      borderRadius:"4px",
      position: "relative",
      zIndex: 0,
      "& .MuiChip-label": {
        color: "#86979C"
      },
      "& .MuiChip-deleteIcon": {
        color: "#d1d1d1bf"
      },
      "&:after": {
        content: '""',
        right: 10,
        top: 6,
        height: 12,
        width: 12,
        position: "absolute",
        backgroundColor: "white",
        zIndex: -1
      }
    }
  })(Autocomplete);

class PeerReview extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        var now = new Date();
        var currentYear = now.getFullYear();
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userEmail: has_local_data ? localdata.user_email : '',
            loading: 1,
            item_count: '',
            isLoadMore: 1,
            selected_peers:[],
            peer_names:[],
            review_id:'',
            Newscore:[],
            myscore:[],
            score:[],
            teamInfo:[],
            peer_question: [],
            formatted_owners: [],
            assign_peers: [],
            defaultList:[],
            errors:[],
            commentReport:[],
            manager_permission:0,
            data_key:0,
            currentYear:currentYear,

        }

       this.onChangeComment = this.onChangeComment.bind(this);
       this.onChangeReview = this.onChangeReview.bind(this);
       this.InsertPeerReview = this.InsertPeerReview.bind(this);
    }

    decryptconfigdata(configkey) {
        
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        
        return plaintext;
    }


    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    ClosePeers(peers,i,key){

        let Peers = [];
        Peers = this.state.myteam[key]['peers'];

        const fd = new FormData;
        fd.append('peers', JSON.stringify(peers));
     
        fetch(this.state.apiUrl + '/MyPerformanceRest/DeletePeers/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            if (findresponse.code == 200) {

                Peers.splice(i,1);
        
                this.state.myteam[key]['peers'] = Peers;

                this.state.myteam[key]['total_peers'] = Peers.length;
                
                console.log(Peers.length);

                console.log(this.state.myteam);

                this.forceUpdate();
            }
        })
    }

    showMorePeers(total_record,itemsToShow,key) {
        
        if(itemsToShow == 5){
            this.state.myteam[key].itemsToShow = total_record;
            this.state.myteam[key].collapse = true;
            this.forceUpdate();
        }else{
            this.state.myteam[key].itemsToShow = 5;
            this.state.myteam[key].collapse = false;
            this.forceUpdate();
        }
    }
    
    ReveiewReport(score,comments){
        this.setState({ Newscore: score });
        this.setState({ commentReport: comments });
        console.log(score);
        console.log(comments);
    }

    handleChange = (selectedList) => {

        console.log("Selected List");

        console.log(selectedList);
        this.setState({
            selected_peers: selectedList,
            waiting:'',
         }, function () {
            //console.log(this.state.primary_email);
		});
    }

    

    InsertPeers() {

        if (this.handlePeersValidation()) {
            console.log("Data Has been submitted");
        } else {
            
            console.log("This Fields Are required.")
            return false;
        }

        this.setState({ waiting: true });

        let Peers = [];
        let key = '';

        key = this.state.clicked_key;

        const fd = new FormData;

        fd.append('selected_peers', JSON.stringify(this.state.selected_peers));
        fd.append('assigned_peers', JSON.stringify(this.state.teamInfo));
        
        fetch(this.state.apiUrl + '/MyPerformanceRest/InsertPeers/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            if (findresponse.code == 200) {

                this.setState({ waiting: '' });

                document.getElementById('dismiss2').click();

                Peers = findresponse.peers;

                console.log(Peers);

                console.log(Peers.length);

                this.state.myteam[key]['peers'] = Peers;

                this.state.myteam[key]['total_peers'] = Peers.length;

                this.forceUpdate();
            }
        })

    }

    ShowAddPeers(teamInfo,clicked_key){

        //console.log(teamInfo.peers);

        //console.log(clicked_key);

        let defaultList = [];

        teamInfo.peers.map(function(users) {
            defaultList.push(users.id);
        })

        console.log(defaultList);
        this.setState({
            teamInfo:teamInfo,
            defaultList:defaultList,
            clicked_key:clicked_key,
            selected_peers: [],
            waiting:'',
            errors: '' 
        })

        console.log(this.state.defaultList);
    }

    getEmployeeList(){
        fetch(this.state.apiUrl + '/MyPerformanceRest/GetAllEmployees/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json'
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            this.setState({
                peer_names: findresponse.peer_names,
            })
        })
    }

    handlePeersValidation(){
        let formIsValid = true;
        let errors = {};


        console.log(this.state.selected_peers);

        if (this.state.selected_peers === undefined || this.state.selected_peers.length == 0) {

            formIsValid = false;
            errors['selected_peers'] = "This field is required.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        var sc = this.state.radio_answers;
        for (let i = 0; i < this.state.peer_question.length; i++) {
            var ques_id = this.state.peer_question[i].id;
            if (!(this.state.score[ques_id])) {
                formIsValid = false;
                errors['score' + ques_id] = "This field is required.";
            }
        }
        /*
        if (this.state.userId == this.state.assignedManager && !(this.state.Comment)) {
            formIsValid = false;
            errors['Comment'] = "This field is required.";
        }*/
        this.setState({ errors: errors });
        return formIsValid;
    }

    // InsertPeerReview() {
       
    //     if (this.handleValidation()) {
    //         console.log("Data Has been submitted");
    //     } else {
            
    //         console.log("This Fields Are required.")
    //         return false;
    //     }

        
    //     var current_key = this.state.data_key ? this.state.data_key : 0;

    //     console.log("Peer Review Key");
    //     console.log(current_key);

        
    //     this.setState({ waiting: true });

    //     const fd = new FormData;

    //     fd.append('score', JSON.stringify(this.state.score));
    //     fd.append('Comment', this.state.Comment);
    //     fd.append('target_user_id', this.state.assigned_id);
    //     fd.append('review_id', this.state.review_id);
        
    //     fetch(this.state.apiUrl + '/MyPerformanceRest/InsertPerformScore/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
    //         method: 'POST',
    //         dataType: 'json',
    //         body: fd,
    //     })
    //     .then((Response) => Response.json())
    //     .then((findresponse) => {
    //         findresponse = this.decrypt(findresponse, 1);
    //         if (findresponse.code == 200) {

    //             console.log(findresponse);

    //             this.setState({ waiting: '' });
                
    //             this.state.mypeers[current_key].review_complete_status = 1;
    //             this.forceUpdate();
               
    //             document.getElementById('dismiss').click();

    //             if(this.state.manager_permission == 1){
    //                 this.MyTeam();
    //             }

    //         }
    //     })
    // }
    InsertPeerReview() {
        let errors = {};
        let valid = true;
    
        // Check if the first question (Overall rating) is rated below 4
        const overallRating = this.state.score[this.state.peer_question[0].id];
        if (overallRating < 4 && !this.state.Comment.trim()) {
            errors['Comment'] = "Feedback is required for overall rating below 4.";
            valid = false;
        }
    
        // Validate individual question ratings
        this.state.peer_question.forEach((data) => {
            const rating = this.state.score[data.id];
            if (!rating) {
                errors['score' + data.id] = "Rating is required for this question.";
                valid = false;
            }
        });
    
        // If validation fails, set errors and stop submission
        if (!valid) {
            this.setState({ errors });
            console.log("Validation failed. Some fields are missing or invalid.");
            return false;
        }
    
        if (!this.handleValidation()) {
            console.log("Some fields are required.");
            return false;
        }
    
        console.log("Data has been submitted.");
    
        var current_key = this.state.data_key ? this.state.data_key : 0;
    
        console.log("Peer Review Key:", current_key);
    
        this.setState({ waiting: true });
    
        const fd = new FormData();
    
        fd.append('score', JSON.stringify(this.state.score));
        fd.append('Comment', this.state.Comment);
        fd.append('target_user_id', this.state.assigned_id);
        fd.append('review_id', this.state.review_id);
    
        fetch(
            this.state.apiUrl +
                '/MyPerformanceRest/InsertPerformScore/userAuthKey/' +
                this.state.userAuthKey +
                '/userId/' +
                this.state.userId,
            {
                method: 'POST',
                dataType: 'json',
                body: fd,
            }
        )
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    console.log(findresponse);
    
                    this.setState({ waiting: '' });
    
                    this.state.mypeers[current_key].review_complete_status = 1;
                    this.forceUpdate();
    
                    document.getElementById('dismiss').click();
    
                    if (this.state.manager_permission == 1) {
                        this.MyTeam();
                    }
                }
            });
    }
    
    onChangeReview(event, id) {
        
        this.state.score[id] = event.target.value;
        this.setState({ errors : '' });
    }

    

    onChangeComment(event) {
        this.setState({ [event.target.name]: event.target.value });
        this.setState({ errors : '' });
    }

    showPeerReview(data_key,id, name, manager, review_id) {

        console.log('Data Key Entry');

        console.log(data_key);

        //alert(this.state.score[this.state.radio_answers])
        var txt = document.getElementsByClassName('comment');
        for (var i = 0; i < txt.length; i++) {
            txt[i].value = '';
        }

        var radiobtn = document.getElementsByClassName("score");
        for (var i = 0; i < radiobtn.length; i++) {
            radiobtn[i].checked = false;
        }

        var radiobtn = document.getElementsByClassName("rate_cl");
        for (var i = 0; i < radiobtn.length; i++) {
            radiobtn[i].checked = false;
        }

        for (let i = 0; i < this.state.peer_question.length; i++) {
            var ques_id = this.state.peer_question[i].id;
            this.state.score[ques_id] = '';
        }
     
        this.setState({
            assignedManager: manager,
            assigned_name: name,
            assigned_id: id,
            review_id:review_id,
            data_key:data_key,
            Comment:'',
            waiting:'',
            errors: '' 
        })

        console.log('State Entry');
        console.log(this.state.data_key);

    }

    
    MyTeam() {
        fetch(this.state.apiUrl + '/MyPerformanceRest/MyTeam/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            console.log(findresponse);
            this.setState({
                myteam: findresponse.myteam
            })
        }).then(() => {
            this.getEmployeeList();
        })
        
    }

    MyPerform() {
        fetch(this.state.apiUrl + '/MyPerformanceRest/MyPerform/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            console.log(findresponse);
        
            this.setState({
                formatted_owners: findresponse.formatted_owners,
                mypeers:findresponse.mypeers,
                peer_question: findresponse.peer_question,
                myscore:findresponse.myscore,
                manager_permission:findresponse.formatted_owners.manager_permission,
                loading: 0,
                currentYear:findresponse.last_review_year
            });

            //console.log(this.state.manager_permission);

        }).then(() =>{

            if(this.state.manager_permission == 1){
                this.MyTeam();
            }
        })
    }

    componentDidMount() {

        document.title = "Intranet | Peer Review";

        if (!localStorage.getItem('userLogin')) {
            
            this.setState({ redirect: true });

        }else{

            document.body.classList.add('peer_review');

            this.MyPerform();

            //this.MyTeam();
        }

    }
    showFeedbacks(){
        fetch(this.state.apiUrl + '/MyPerformanceRest/ViewReport/id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    comments: findresponse.comments
                })
            })
        window.$("#show_feedback").modal('show');
        console.log(410,this.state.comments);
    }

    render() {


        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        const filterOptions = createFilterOptions({
            matchFrom: 'start',
            stringify: option => option.name,
        });


        return (
            <div>
                <Header brecum_name="Peer Review" brecum_page="Peer Review" />
                <div className="right_col">
                    <div className="intranet_body">
                        <div class="title mob hidden-sm">
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            <span> Peer Review</span>
                            <div class="mob-search hidden-md pull-right">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class = "peer_review">
                        <div class="peer_area peer_fixed-desig">
                            <div class="peer_user-desig">
                                <div class="row">
                                    <div class="media col-md-8 col-sm-8 c0l-xs-12">
                                        <Link key={this.state.formatted_owners.id} to={`/viewEmployee/${this.state.formatted_owners.id}`} name={"max"} class = 'quiz_emp_link'>
                                        <div class="media-left">
                                            <div class="peer_user_img">
                                            {
                                                this.state.formatted_owners.attachment ?
                                                <img src={this.state.formatted_owners.attachment} />
                                                : <span class="quiz_first_name">{this.state.formatted_owners.img_name}</span>
                                            }
                                            </div>
                                        </div>
                                        </Link>
                                        <div class="media-body">
                                            <div class="peer_emp_name_designation">
                                                <div class="peer_emp_name">
                                                {
                                                    this.state.formatted_owners.name ?
                                                    this.state.formatted_owners.name
                                                    :''
                                                }
                                                </div>
                                                <ul class="desi_peer_details">
                                                    <li><span><i class="far fa-suitcase"></i></span>
                                                    {this.state.formatted_owners.position ?
                                                    this.state.formatted_owners.position
                                                    :''}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-4 c0l-xs-12">
                                        <div class="media-body">
                                            <div class="peer_text tooltips">
                                                <div class="color_sub">My Score & Feedback</div>
                                                <div class="tooltiptext">
                                                    <div class="tip_name">View Feedback</div>
                                                </div>
                                                {this.state.myscore[0] ?
                                                <div class="peer_rating" title="View Feedback" onClick={() => this.showFeedbacks()}>{this.state.myscore[0] ?this.state.myscore[0]+ "/5" :"--"}</div>
                                                :
                                                <div class="peer_rating" >{this.state.myscore[0] ?this.state.myscore[0]+ "/5" :"--"}</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <section class="tabs_area">
                            <div id="exTab1" class="container">
                                <ul class="nav nav-pills nav-tabs">
                                    <li class="active"><a href="#my_peers" data-toggle="tab">My Peers</a>
                                    </li>
                                    {this.state.manager_permission == 1 ? 
                                        <li><a href="#my_team" data-toggle="tab">My Team</a> </li>
                                        
                                    :""}
                                </ul>
                            </div>
                            <div class="tab-content customer-tab clearfix">
                                <div class="tab-pane container active" id="my_peers">
                                    <div class="tab-pane active" id="kk">
                                        
                                    <ul class="tickets_head tabl_heading">
                                        <li class="intra_col_20">Employee Name</li>
                                        {/*<li class="intra_col_20">Pod</li>*/}
                                        <li class="intra_col_60">Department</li>
                                        <li class="intra_col_20">Action</li>
                                    </ul>
                                    
                                    {
                                        this.state.mypeers?this.state.mypeers.map((data, key) =>
                                            
                                        <ul class="tickets_number peer-details-container">
                                            <li class="intra_col_20">
                                                <div class="emps_details">
                                                    <div class="emps_pic">{data.attachment ? <img src={data.attachment} /> : <span class="quiz_emp_first_name_small">{data.img_name}</span>}</div>
                                                    <Link key={key} to={`/viewEmployee/${data.id}`} name={"max"}>{data.name}</Link>
                                                </div>
                                            </li>
                                            {/* <li class="intra_col_20">{data.pod}</li> */}
                                            <li class="intra_col_60">{data.department?data.department:'--'}</li>
                                            <li class="intra_col_20">
                                                {data.review_complete_status==1 ? <div>Submitted for {data.review_quarter} {this.state.currentYear}</div> : <span class="peer-mark" onClick={() => this.showPeerReview(key,data.id, data.name, data.manager, data.review_id)}data-toggle="modal" data-target="#PerformQuestion" data-dismiss="modal" >Submit Review for {data.review_quarter} {this.state.currentYear}</span>}
                                            </li>
                                        </ul>
                                        ):''
                                    } 
                                    </div>
                                </div>

                                {this.state.manager_permission  == 1 ?
                                <div class="tab-pane container" id="my_team">
                                    <div class="tab-pane" id="Login">
                                        <ul class="tickets_head tabl_heading">
                                            <li class="intra_col_20">
                                                <span>Employee Name</span>
                                            </li>
                                            <li class="intra_col_10">Score</li>
                                            <li class="intra_col_70">Peers</li>
                                        </ul>
                                        
                                        {
                                            this.state.myteam?this.state.myteam.map((data, key) =>
                                                    
                                            <ul class="tickets_number peer-details-container">
                                            
                                            <li class="intra_col_20">
                                                <div class="emps_details emps_cus">
                                                    <div class="emps_pic emps_pic_cus">
                                                        {
                                                            data.attachment ? <img src={data.attachment} />
                                                            : <span class="quiz_emp_first_name_small">{data.img_name}</span>
                                                        }
                                                    </div>
                                                    <Link key={data.id} to={`/viewEmployee/${data.id}`} name={"max"} class = 'quiz_emp_link'>{data.name}</Link>
                                                </div>
                                            </li>
                                            <li class="intra_col_10">
                                                <div class="muBtn" onClick={() => this.ReveiewReport(data.score,data.comments)} data-toggle="modal" data-target="#AssignedResult" data-dismiss="modal">
                                                    { data.score[0]? data.score[0] + "/5" :"--"}
                                                </div>
                                            </li>
                                            <li class="intra_col_70">
                                           
                                            {data.peers.slice(0, data.itemsToShow).map((peer, i) => {
                                            
                                            return <div class="mab-bootstrap-taginput-tag">{peer.name}<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                            
                                            onClick={() => { if (window.confirm('Are you sure want to remove this Peer?'))this.ClosePeers(peer,i,key) } }

                                            ><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                            </div>

                                            })}
                                            
                                            {(data.total_peers > data.itemsToShow || data.collapse)?

                                            <div className="show-more-tag" onClick={() => this.showMorePeers(data.total_peers,data.itemsToShow,key)}>
                                                {data.collapse ? <span> Show less</span> : <span>{data.total_peers - data.itemsToShow + ' More'}</span>}
                                            </div> : ""
                                            }

                                            <div class="addBtn" data-toggle="modal" data-target="#AddPeers" onClick={() => this.ShowAddPeers(data,key)}>
                                                <i class="far fa-plus"></i>
                                            </div>

                                            </li>
                                        </ul>
                                            
                                        ):''} 

                                    </div>
                                </div>
                                : ""}
                            </div>
                        </section>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            
                
                <div class="modal fade" id="AssignedResult" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 class="modal-title">Peer Score</h4>
                            </div>
                            <div class="modal-body">
                                <div class="row">

                                    <div class="peer-pop">
                                        <div class="add_dash">
                                            <div class="dash_price">{this.state.Newscore[0] ? this.state.Newscore[0] : '--' }</div>
                                            <div class="dash_wb">Overall Score</div>
                                        </div>
                                    </div>

                                </div>
                                <div class="list_check peer-row">
                                    <div class="tickets">
                                        <ul class="tickets_head">
                                            <li class="col-md-9 col-xs-8"><span class="peer-comment">Indicators</span></li>
                                            <li class="col-md-3 col-xs-4"><span class="peer-comment">Average Score</span></li>
                                        </ul>
                                        <div class="peer-block">
                                            {this.state.peer_question.map
                                            ((data, key) =>
                                                <ul className="tickets_number">
                                                    <li class="col-md-9 col-xs-8">
                                                    <h5>{data.question}</h5>
                                                    <p>{data.ques_description}</p>
                                                    </li>
                                                    <li class="col-md-3 col-xs-4 peer_res">
                                                        {this.state.Newscore[key] ?  this.state.Newscore[key] : "--"}
                                                    </li>
                                                </ul>
                                            )}</div>
                                    </div>
                                </div>
                                
                                {Object.keys(this.state.commentReport).length > 0 ? 
                                <span >Overall Notes:
                                    <div class="peer-comment note">
                                        {this.state.commentReport.map
                                        ((data, key) =>
                                            <div class="peer_comt" dangerouslySetInnerHTML={{ __html: data }} />
                                        )}
                                    </div>
                                </span> : ""}
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="modal fade" id="PerformQuestion" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-body">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 class="modal-title">Submit peer review for {this.state.assigned_name}</h4>
                                <h5><i>Note: Peer reviews are completely anonymous</i></h5>
                                <h6 class="rate-tit">Rate from 1 to 5, 1-Terrible, 2-Poor, 3-Average, 4-Good, 5-Great</h6>
                                <div class="modal-box submit-box">
                                    <div class="list_check peer-row">
                                        <div class="peer-block">
                                            {this.state.peer_question.map
                                                ((data, key) =>
                                                    <ul className="tickets_number">
                                                        <li class="form-group">
                                                            <div class="peer_ques"><span class="ques">{data.question}</span></div><div><span class="peer_qustn">{data.ques_description}</span></div>
                                                                <div class="rate">
                                                                <input type="radio" id={"star" + data.id + '_5'} class="rate_cl" name={"rate" + data.id} value={5} onChange={event => this.onChangeReview(event, data.id)} />
                                                                <label for={"star" + data.id + '_5'} title="text">5 stars</label>
                                                                <input type="radio" id={"star" + data.id + '_4'} class="rate_cl" name={"rate" + data.id} value={4} onChange={event => this.onChangeReview(event, data.id)} />
                                                                <label for={"star" + data.id + '_4'} title="text" >4 stars</label>
                                                                <input type="radio" id={"star" + data.id + '_3'} class="rate_cl" name={"rate" + data.id} value={3} onChange={event => this.onChangeReview(event, data.id)} />
                                                                <label for={"star" + data.id + '_3'} title="text">3 stars</label>
                                                                <input type="radio" id={"star" + data.id + '_2'} class="rate_cl" name={"rate" + data.id} value={2} onChange={event => this.onChangeReview(event, data.id)} />
                                                                <label for={"star" + data.id + '_2'} title="text" >2 stars</label>
                                                                <input type="radio" id={"star" + data.id + '_1'} class="rate_cl" name={"rate" + data.id} value={1} onChange={event => this.onChangeReview(event, data.id)} />
                                                                <label for={"star" + data.id + '_1'} title="text">1 star</label>
                                                            </div>
                                                            <span class="error">{this.state.errors['score' + data.id]}</span>
                                                        </li>
                                                    </ul>
                                                )}
                                        </div>
                                        <div>
                                            <textarea placeholder="Please share some more feedback..." name="Comment" id="comment"  class="form-control comment" onChange={this.onChangeComment} >Note</textarea>
                                            <span class="error">{this.state.errors['Comment']}</span>
                                        </div>
                                        <span style={{color: "green"}}>{this.state.message}</span>
                                    </div>
                                    <div class="modal-footer">
                                        {this.state.waiting ?  <button type="submit" class="btn btn-sky disabled" ><div><i class="fa fa-spinner fa-spin"></i><span> Submitting</span></div></button> : <button type="submit" name="add_score" id="add_score"  class="btn btn-sky" onClick={() => this.InsertPeerReview()}  >
                                        Submit</button>}

                                        <button type="buttom" data-dismiss="modal" class = "hide"  id = "dismiss"></button>
                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="peer">
                    <div class="modal fade in" id="AddPeers" tabindex="-1" role="dialog" aria-labelledby="AddPeers" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-dialog modal-md" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Add Peers</h4>
                                    <button type="button" class="close" data-dismiss="modal">×</button>
                                </div>
                                <div class="modal-body row">
                                    <div class="col-md-12 col-sm-12 c0l-xs-12">
                                        <div class="media-left">
                                            <div class="peer_user_img">
                                            {
                                                this.state.teamInfo.attachment ?
                                                <img src={this.state.teamInfo.attachment} />
                                                : <span class="quiz_first_name">{this.state.teamInfo.img_name}</span>
                                            }
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <div class="peer_emp_name_designation">
                                                <div class="peer_emp_name">{this.state.teamInfo.name ? this.state.teamInfo.name: ""}</div>
                                                <ul class="desi_peer_details">
                                                    <li><span><i class="far fa-suitcase"></i></span>{this.state.teamInfo.position ? this.state.teamInfo.position: ""}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3 float-left popup_tag_area">
                                        <form>
                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                            <div>
                                                
                                                {this.state.peer_names.length>0?
                                                
                                                <CustomAutocomplete
                                                multiple
                                                options={this.state.peer_names}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(event , value) => this.handleChange(value)}
                                                getOptionDisabled={(option) => !! this.state.defaultList.find(element => element === option.id)}
                                                value={this.state.selected_peers}
                                                filterOptions={filterOptions} 
                                                filterSelectedOptions
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        //label="Users Names"
                                                        placeholder="Select"
                                                    />
                                                    )}
                                            /> :''}
                                            
                                                </div>
                                            </div>
                                        </div>
                                        <span class="error ml-10">{this.state.errors['selected_peers']}</span>
                                        </form>
                                    </div>
                                </div>
                                
                                <div class="modal-footer">

                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Dismiss</button>
                                    
                                    {this.state.waiting ?  <button type="submit" class="btn btn-sky disabled" ><div><i class="fa fa-spinner fa-spin"></i><span> Adding</span></div></button> : <button type="button" class="btn btn-sky" onClick={() => this.InsertPeers()}> Add</button>}

                                    <button type="buttom" data-dismiss="modal" class = "hide" id = "dismiss2"></button>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* modal Start for showing Feedback*/}
                <div class="show_feedback">
                   <div class="modal fade" id="show_feedback" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">My Feedbacks</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="peer-comment note">
                                        {this.state.comments && this.state.comments.length > 0 ? this.state.comments.map
                                            ((data, key) =>
                                                <div class="peer_comment" dangerouslySetInnerHTML={{ __html: data }} />
                                                        ):<div class="peer_comment feedback_cls">No Feedbacks Yet</div>}
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default PeerReview;


// WEBPACK FOOTER //
// ./src/components/MyPerformance/peerReview.js